import type React from 'react';

import { Button, Separator } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { useFormFooter } from './hooks/useFormFooter';

export const FormFooter: React.FC = () => {
	const { data, actions } = useFormFooter();

	return (
		<div
			id="form-footer-box"
			className="bg-background-base sticky bottom-0 z-10 w-full px-4 pb-8 text-right md:px-12 md:pb-12"
		>
			<Separator className="m-0!" />
			<div className="container py-4">
				<Button
					className="w-40"
					variant="primary"
					disabled={data.isSubmitting}
					size="small"
					onClick={actions.handleSubmit}
					data-qa="edit-save-button"
				>
					<Translate value="corgi.petition.edit.save" />
				</Button>
			</div>
		</div>
	);
};
